import Vue from 'vue'
import { cancelAnimationFrame, requestAnimationFrame } from '@/utils/helpers'

/*
 * スクロール値の保存やスクロール方向の判定などを行う
 */
export default Vue.extend({
  data() {
    return {
      $_smFrameID: null,
      $_isScrollUp: false,
      $_isScrolling: false,
      $_scrollTimer: null,
      $_oldScrollTop: 0,
      virtualScrollY: 0
    }
  },
  computed: {
    $_currentModuleName(): string {
      let moduleName = ''
      if (this.$route.name === 'home') moduleName = 'TopUser'
      else if (this.$route.name === 'message') moduleName = 'MessageList'
      else if (this.$route.name === 'timeline') moduleName = 'Timeline'
      else if (this.$route.name === 'timeline/user') moduleName = 'TimelineUser'
      else if (this.$route.name === 'footprint/list') moduleName = 'Footprint'
      return moduleName
    }
  },
  mounted() {
    this.$nextTick().then(() => {
      this.virtualScrollY = this.$_currentModuleName
        ? this.$store.getters[`${this.$_currentModuleName}/savedPosition`].y
        : 0
    })

    window.addEventListener('scroll', this.$_onScroll, false)
  },
  destroyed() {
    window.removeEventListener('scroll', this.$_onScroll, false)
  },
  methods: {
    $_onScroll() {
      this.$_isScrolling = true
      clearTimeout(this.$_scrollTimer)
      this.$_scrollTimer = setTimeout(() => {
        this.$_isScrolling = false
      }, 0)
      if (this.$_smFrameID) {
        return
      }
      this.$_smFrameID = requestAnimationFrame(() => {
        this.$_isScrollUp = this.$_oldScrollTop > window.pageYOffset
        this.$_oldScrollTop = window.pageYOffset

        this.$_savedPosition()

        cancelAnimationFrame(this.$_smFrameID)
        this.$_smFrameID = null
      })
    },

    /**
     *  pull refresh 実装ページのスクロール値を保存する
     */
    $_savedPosition() {
      if (this.$_currentModuleName) {
        this.$store.commit(`${this.$_currentModuleName}/setSavedPosition`, {
          x: window.pageXOffset,
          y: window.pageYOffset
        })
      }
    },

    /**
     * スクロール位置を復元する
     */
    $_restoreScrollY() {
      window.scrollTo(0, this.virtualScrollY)
    }
  }
})
